
import Index from '~/pages/franchise-directory/index'
export default Index
